import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, withTypography } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { primitive, spacing } from 'styles/constants';

const styles = StyleSheet.create({
  orderEtaContainer: {
    alignItems: 'center',
    backgroundColor: primitive.$blackOpacity4,
    borderRadius: primitive.$borderRadius,
    flexDirection: 'row',
    justifyContent: 'center',
    maxHeight: spacing.$10,
    padding: spacing.$1,
  },
});

export const OrderEtaContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.orderEtaContainer, style] });

export const OrderEtaDescription = withTypography({ ml: '$2' });
